import { useState } from 'react'

export const QuestionsSection: React.FC = () => {
  const faqs = [
    {
      q: 'いま注文するといつ届きますか？',
      a: <p>お申し込みから最短の日程でお届けします。申し込み画面にて、郵便番号入力後に確定の日付が表示されますので、ご確認ください。</p>,
    },
    {
      q: 'どのような手段で配送されますか？',
      a: <p>クロネコヤマトの宅急便でのお届けとなります。</p>,
    },
    {
      q: '受け取り時間帯を指定することはできますか？',
      a: <p>はい。商品の発送完了メールに記載されているクロネコヤマトの追跡URLより、受け取り時間帯を変更いただけます。クロネコメンバーズ（無料）に登録しておくと、次回以降は発送時にヤマト運輸からお届け予定の通知が届き、そこから直接受け取り日時の変更ができるようになります。また、ヤマト運輸公式アプリをインストールいただくとLINEと連携することも可能です。</p>,
    },
    {
      q: '夏期はクール便になりますか？',
      a: (
        <p>
          はい。6〜9月頃は、品質を保つためクール便でお届けします。1配送あたり+300円（税込330円）が加算されます。
          ※北海道エリアのみ、冬期（12〜3月予定）もクール便での配送となります。
        </p>
      ),
    },
    {
      q: '不在で受け取りができない時はどうすればいいですか？',
      a: <p>旅行や出張などで荷物の受け取りができない場合は、スキップ機能をご利用ください。お届けを1回分お休みすることができます。次回発送の3日前の正午までに、マイページからお手続きをお願いします。</p>,
    },
    {
      q: '毎月何本届きますか？',
      a: <p>5本以上をお届けします。仕入れ状況によって本数は変わりますが、ボリューム感を大切にしています。実際のお届け例は写真でご確認ください。</p>,
    },
    {
      q: 'どんな花器を使えばいいですか？',
      a: (
        <p>
          枝ものを入れるならサイズと安定感がポイントです。高さは20cm以上、大ぶりの枝が倒れないよう、重心が低くしっかりしたものを選ぶのがおすすめです。FLOWERでは枝もののサイズに合わせたフラワーベースをご用意しているので、初回ご注文時にあわせてどうぞ。
        </p>
      ),
    },
    {
      q: '花器も同時に購入しました。一緒に届きますか？',
      a: <p>はい。枝と同じタイミングでお届けしますので、届いてすぐ飾っていただけます。</p>,
    },
    {
      q: '届いた枝ものが傷んでいた場合は？',
      a: (
        <p>もし商品が「枯れている」「折れている」などの不備がございましたら、返金もしくは代品にて補償が可能です。お気軽にサポートまでお問い合わせください。</p>
      ),
    },
    {
      q: '虫がついていた場合はどうすればいいですか？',
      a: (
        <>
          <p>
            枝ものは屋外で育つため、まれに虫がついていることがあります。出荷時に目視で確認を行っていますが、小さな卵などが付着している場合は除去しきれない場合もございます。気になる場合は、以下の方法をお試しください。
          </p>
          <ul className="list-disc list-inside space-y-1 pl-4">
            <li>届いたらベランダや屋外で軽く振り、虫を落とす</li>
            <li>葉や枝をやさしくシャワーや水で洗い流す</li>
            <li>虫がついている部分ごと取り除く</li>
            <li>花器と水を清潔に保つ</li>
          </ul>
          <p>必要に応じて、植物に使用できる虫除けスプレーのご使用もおすすめです。早めに対処すれば問題なくお楽しみいただけます。</p>
        </>
      ),
    },
    {
      q: '決済手段は何がありますか？',
      a: <p>Visa・Mastercard・Amex・JCB・DinersClub・Discoverでお支払いいただけます。</p>,
    },
    {
      q: '領収書の発行はできますか？',
      a: <p>商品の発送完了メール内に記載された、領収書のダウンロードボタンより発行してください。</p>,
    },
    {
      q: 'お届け頻度（月1回/月2回）は変更できますか？',
      a: <p>はい。次回発送の3日前の正午までに、マイページからお手続きください。</p>,
    },
    {
      q: 'いつでも解約できますか？',
      a: <p>はい、いつでも解約できます。次回発送の3日前の正午までに、マイページからお手続きをお願いします。</p>,
    },
  ]

  return (
    <section id="faq" className="py-20 md:py-28 bg-bg px-5">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-center text-2xl md:text-3xl font-medium text-black leading-relaxed">よくある質問</h2>
        <div className="mt-12 divide-y divide-gray/50">
          {faqs.map((faq, i) => (
            <FAQItem key={i} q={faq.q} a={faq.a} />
          ))}
        </div>
      </div>
    </section>
  )
}

const FAQItem: React.FC<{ q: string; a: React.ReactNode }> = ({ q, a }) => {
  const [open, setOpen] = useState(false)
  const style = {
    overflow: 'hidden',
    maxHeight: open ? '600px' : '0',
    transition: open ? 'max-height 0.7s ease' : 'max-height 0.4s ease',
  }

  return (
    <div className="py-5" onClick={() => setOpen(!open)}>
      <button className="w-full flex items-start justify-between gap-4 text-left cursor-pointer">
        <span className="text-[16px] text-black font-medium leading-relaxed">{q}</span>
        <span
          className="mt-0.5 text-dark-gray text-lg shrink-0 transition-transform duration-200"
          style={{ transform: open ? 'rotate(45deg)' : 'rotate(0deg)' }}
        >
          +
        </span>
      </button>
      <div style={style}>
        <div className="mt-3 cursor-auto text-[15px] text-main leading-[1.9] pr-8 space-y-2">{a}</div>
      </div>
    </div>
  )
}
